<script>
import ElTableColumn from '../../element-ui/packages/table-column';
export default {
  name: 'RtTableColumn',
  components: { ElTableColumn },

  props: {
    fixed: [String, Boolean],
    autoFixed: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    showOverflowTooltip: {
      type: Boolean,
      default: true
    },
    prop: {
      type: String,
      default: ''
    }
  },

  render (h) {
    const classes = [];
    if (this.fixed) {
      classes.push('rt-fixed-column');
    }
    if (this.autoFixed) {
      classes.push(`rt-fixed-column rt-fixed-column-${this.className}`);
    }

    if (!rt.isNilOrEmptyArray(this.$attrs.sortable) && this.$attrs.align === 'right') {
      classes.push('is_sortable');
    }

    const options = {
      attrs: { ...this.$attrs, resizable: !this.$scopedSlots.edit },
      props: Object.assign({}, this.$props, {
        className: classes.join(' ')
      })
    };
    if (this.$scopedSlots.default || this.$scopedSlots.header || this.$scopedSlots.headerSuffix || this.$scopedSlots.edit) {
      options.scopedSlots = { };
    }

    if (this.$scopedSlots.default) {
      options.scopedSlots.default = props => {
        return this.$scopedSlots.default({
          row: props.row,
          $index: props.$index
        })
      }
    };

    if (this.$scopedSlots.header) {
      options.scopedSlots.header =
         props => {
           return this.$scopedSlots.header({
             column: props.column,
             $index: props.$index
           })
         }
    }

    if (this.$scopedSlots.headerSuffix) {
      options.scopedSlots.headerSuffix =
         props => {
           return this.$scopedSlots.headerSuffix({
             column: props.column,
             $index: props.$index
           })
         }
    }

    if (this.$scopedSlots.edit) {
      options.scopedSlots.edit =
         props => {
           return this.$scopedSlots.edit({
             row: props.row,
             $index: props.$index
           })
         }
    }

    return h('el-table-column', options, this.$slots.default);
  }
};
</script>



// WEBPACK FOOTER //
// rtTableColumn.vue?622dd574